"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "INTERNAL_API_MODULE_PROVIDER_KEY", {
    enumerable: true,
    get: function() {
        return INTERNAL_API_MODULE_PROVIDER_KEY;
    }
});
const INTERNAL_API_MODULE_PROVIDER_KEY = 'INTERNAL_API_MODULE';
